module.exports = __webpack_public_path__ + "static/media/attendance.3af1a3f7.svg";